import type { FullyWatchedItem } from "@sunrise/backend-types";
import { atomWithArrayUpdates } from "@sunrise/utils";

export const fullyWatchedSocketUpdatesAtom =
  atomWithArrayUpdates<FullyWatchedItem>([], {
    compareFn: (a, b) => a.epg_entry.id === b.epg_entry.id,
    debugLabel: "fullyWatchedSocketUpdates",
  });
